<script>
  import options from './CardListFeaturedContent.options'
  const componentOptions = options
  export default componentOptions
</script>

<template>

   <!-- Backend dev notes: colorthemes set by editor -->
   <section class="be-card-list be-card-list-featured-content be-color-theme--white-black" >
    <div class="be-card-list__content-wrapper">
      <h2 class="be-font-heading-2 be-card-list__title">{{title}}</h2>

      <ul class="be-card-list-featured-content__cards-grid">

          <li class="be-card-list-featured-content__card-wrapper-highlighted" >
            <ContentCard :result="cardsResult[0]" />
          </li>
         
          <template v-for="(card, index) in cardsResult" :key="index">  
            <template v-if="index > 0">
              <li :class="`be-card-list-featured-content__card-wrapper-remaining-${index}`" >
                <ContentCard :result="card" />
              </li>
            </template>
          </template>
        
      </ul>

      <div class="be-color-theme--white-green" v-if="ctaLink?.link && ctaLink?.buttonText">
          <a :href="ctaLink.link" class="be-btn be-btn--outline">{{ ctaLink.buttonText }}</a>
      </div>

    </div>
  </section>
  
</template>
